import { render, staticRenderFns } from "./LatestRegisteredVolunteers.vue?vue&type=template&id=650135c2&scoped=true&"
import script from "./LatestRegisteredVolunteers.vue?vue&type=script&lang=js&"
export * from "./LatestRegisteredVolunteers.vue?vue&type=script&lang=js&"
import style0 from "./LatestRegisteredVolunteers.vue?vue&type=style&index=0&id=650135c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650135c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSparkline } from 'vuetify/lib/components/VSparkline';
installComponents(component, {VAvatar,VBtn,VCard,VCardActions,VCardText,VDataTable,VDivider,VExpandTransition,VIcon,VSheet,VSparkline})
